import React, {useCallback, useState} from 'react';
import {IntegrationFormStepsStyle} from "../../constants/AppConstants";
import {Box, Step, StepContent, StepLabel, Stepper} from "@mui/material";
import cx from "classnames";
import {ApiEndPointEditor} from "../apiEndpointEditor/ApiEndPointEditor";
import {toast} from "react-toastify";
import {showError} from "../../utils/NotificationUtils";
import {useIntegrationsContext} from "../../api/integrations/IntegrationsContext";
import {useParams} from "react-router";
import {IntegrationEventTest} from "./IntegrationEventTest";

interface Props {
    readonly [key: string]: any
}

export function IntegrationEventSteps({...props}: Props) {
    const classes = IntegrationFormStepsStyle();
    const [activeSteps, setActiveSteps] = useState<number[]>([0]);
    const {IntegrationsApi} = useIntegrationsContext();
    const params: any = useParams();

    const onSetActive = (num: number) => {
        setActiveSteps(prev => {
            if (prev.includes(num)) {
                const idx = prev.indexOf(num);
                return [...prev.slice(0, idx), ...prev.slice(idx + 1)]
            } else {
                return [...prev, num]
            }
        })
    };

    const configureApiEndpoint = useCallback((values) => {
        console.log(values)
        const status = toast.loading("Saving...");
        IntegrationsApi.IntegrationApiEndpointConfigure(
            `/${props.isTrigger ? "trigger" : "action"}/:id/api-endpoint`, {
                method: values.method,
                params: values.params,
                headers: values.headers,
                requestBody: values.requestBody,
                source: values.source,
                switchedToSource: values.switchedToSource,
                url: values.url
            }, {
                id: props.isTrigger ? params.triggerId : params.actionId
            }).then(() => {
            toast.success("Saved");
            toast.dismiss(status)
        }).catch(err => {
            toast.dismiss(status);
            showError(err)
        })
    }, [IntegrationsApi, params, props]);

    return (
        <Box className={classes.root}>
            <Stepper orientation="vertical">
                <Step active={activeSteps.includes(0)} className={cx(classes.stepRoot, {
                    "active": activeSteps.includes(0)
                })}>
                    <StepLabel onClick={() => onSetActive(0)}>
                        <div className={classes.stepOrder}>
                            Step <span>{1}</span>
                        </div>
                        <span className={classes.labelTitle}>Configure your API Request</span>
                    </StepLabel>
                    <StepContent>
                        <div className={classes.content}>
                            <ApiEndPointEditor apiEndpoint={props.data?.apiEndpoint}
                                               handleSubmit={(data) => configureApiEndpoint(data)}
                                               onChange={(data) => props.onChange("apiEndpoint", data)}/>
                        </div>
                    </StepContent>
                </Step>
                <Step active={activeSteps.includes(1)} className={cx(classes.stepRoot, {
                    "active": activeSteps.includes(1)
                })}>
                    <StepLabel onClick={() => onSetActive(1)}>
                        <div className={classes.stepOrder}>
                            Step <span>{2}</span>
                        </div>
                        <span className={classes.labelTitle}>Test your API Request</span>
                    </StepLabel>
                    <StepContent>
                        <div className={classes.content}>
                            <IntegrationEventTest isTrigger={props.isTrigger}/>
                        </div>
                    </StepContent>
                </Step>
            </Stepper>
        </Box>
    );
}

